import { primaryColor } from "../palette";

export const MuiPaginationItem = {
  MuiPaginationItem: {
    root: {
      color: primaryColor,
    },
    outlined: {
      border: "1px solid",
      borderColor: primaryColor,
    },
  },
};
